// Component to render diarized transcript with speaker labels
const SPEAKER_STYLES = {
  Provider: {
    bg: 'bg-purple-50',
    border: 'border-l-purple-500',
    badge: 'bg-purple-100 text-purple-800',
    text: 'text-gray-800',
  },
  Patient: {
    bg: 'bg-slate-50',
    border: 'border-l-slate-400',
    badge: 'bg-slate-200 text-slate-700',
    text: 'text-gray-800',
  },
  Speaker: {
    bg: 'bg-gray-50',
    border: 'border-l-gray-300',
    badge: 'bg-gray-100 text-gray-600',
    text: 'text-gray-700',
  },
};

function parseTurns(text) {
  const lines = text.split('\n').filter((l) => l.trim());
  const turns = [];
  let current = null;

  for (const line of lines) {
    const providerMatch = line.match(/^Provider:\s*(.*)/i);
    const patientMatch = line.match(/^Patient:\s*(.*)/i);
    const speakerMatch = line.match(/^Speaker:\s*(.*)/i);

    if (providerMatch) {
      if (current) turns.push(current);
      current = { speaker: 'Provider', text: providerMatch[1] };
    } else if (patientMatch) {
      if (current) turns.push(current);
      current = { speaker: 'Patient', text: patientMatch[1] };
    } else if (speakerMatch) {
      if (current) turns.push(current);
      current = { speaker: 'Speaker', text: speakerMatch[1] };
    } else if (current) {
      current.text += '\n' + line;
    } else {
      turns.push({ speaker: 'Speaker', text: line });
    }
  }
  if (current) turns.push(current);
  return turns;
}

export function DiarizedTranscript({ text }) {
  const turns = parseTurns(text);
  return (
    <div className="space-y-3" data-testid="diarized-transcript-view">
      {turns.map((turn, idx) => {
        const style = SPEAKER_STYLES[turn.speaker] || SPEAKER_STYLES.Speaker;
        return (
          <div key={idx} className={`${style.bg} border-l-4 ${style.border} rounded-r-xl p-4`}>
            <span className={`inline-block text-xs font-semibold px-2 py-0.5 rounded-full mb-1.5 ${style.badge}`}>
              {turn.speaker}
            </span>
            <p className={`text-sm leading-relaxed ${style.text}`}>{turn.text.trim()}</p>
          </div>
        );
      })}
    </div>
  );
}
